import React from "react";
import biswabangla from "../../assets/images/biswabangla.png";
import sudaImg from "../../assets/images/suda.jpeg";
import ulbImg from "../../assets/images/ULB.jpeg";
import { useNavigate } from "react-router-dom";

const roles = [
  { title: "SUDA", image: sudaImg, path: "/suda/login" },
  { title: "ULB", image: ulbImg, path: "/ulb/login" },
];


const Landing = () => {
    const navigate = useNavigate();

  return (
    <div
      className="min-vh-100 d-flex flex-column align-items-center"
      style={{
        backgroundColor: "#3e7ff6",
      }}
    >
      <div className="text-center text-white mt-4">
        <img src={biswabangla} alt="Logo" style={{ width: 130 }} />
        <h2
          className="fw-bold mt-3"
          style={{
            color: "white",
            opacity: 0.92,
            textShadow: "2px 4px 8px rgba(0,0,0,0.35)",
            letterSpacing: "0.5px",
          }}
        >
          {/* Urban School Uniform Stitching Project Management System */}
          Smart Urban Uniform Management System
        </h2>

        <h3 className="fw-semibold">(SUUMS)</h3>
      </div>

      <div className="container mt-5">
        <div className="row justify-content-center g-4">
          {roles.map((role, index) => (
            <div className="col-md-5" key={index}>
              <div
                className="card text-center h-100"
                onClick={() => navigate(role.path)}
                style={{
                  background: "rgba(255,255,255,0.95)",
                  borderRadius: "20px",
                  border: "1px solid rgba(255,255,255,0.4)",
                  backdropFilter: "blur(10px)",
                  boxShadow: "0 20px 40px rgba(0,0,0,0.15)",
                  cursor: "pointer",
                  transition: "all 0.35s ease",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform =
                    "translateY(-8px) scale(1.02)";
                  e.currentTarget.style.boxShadow =
                    "0 30px 60px rgba(0,0,0,0.25)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "none";
                  e.currentTarget.style.boxShadow =
                    "0 20px 40px rgba(0,0,0,0.15)";
                }}
              >
                <div className="card-body py-5">
                  <div
                    className="rounded-circle d-flex align-items-center justify-content-center mx-auto mb-4"
                    style={{
                      width: 130,
                      height: 130,
                      background: "linear-gradient(135deg, #ffffff, #e3f2fd)",
                      boxShadow: "0 10px 25px rgba(0,0,0,0.2)",
                      border: "4px solid #3e7ff6",
                    }}
                  >
                    <img
                      src={role.image}
                      alt={role.title}
                      style={{
                        width: "90px",
                        height: "90px",
                        objectFit: "contain",
                      }}
                    />
                  </div>

                  <h3
                    className="fw-bold"
                    style={{
                      color: "#1a237e",
                      letterSpacing: "1px",
                      marginTop: "10px",
                    }}
                  >
                    {role.title} LOGIN
                  </h3>
                  <div style={{ fontSize: 32, color: "black" }}>→</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Landing;
